<div class="container-fluid pb-5 bg-light">
  <!-- Page Header -->
  <div class="mb-4">
    <h3 class="fw-bold text-dark">
      <span class="lstick"></span> Charity Transaction Details
    </h3>
  </div>

  <div *ngIf=" details">

    <div class="card mb-4 shadow-sm">
      <h4 class="card-header fw-bold">Transaction Summary</h4>
      <div class="card-body row">
        <div class="col-md-4"><b>Order Number:</b> {{ details.orderNumber }}</div>
        <div class="col-md-4"><b>Invoice Number:</b> {{ details.invoice_number }}</div>
        <div class="col-md-4">
          <b>Status: </b>
          <span class="badge" [ngClass]="details.isPaid ? 'bg-success' : 'bg-warning'">
            {{ details.isPaid ? 'Paid' : 'Pending' }}
          </span>
        </div>

        <div class="col-md-4 mt-2"><b>Charity Percentage:</b> {{ details.donationPercentage }}%</div>
        <div class="col-md-4 mt-2"><b>Charity Amount:</b> {{ details.amount }} {{ currency }}</div>
        <div class="col-md-4 mt-2"><b>Date:</b> {{ details.created_at | date:'medium' }}</div>
      </div>
    </div>

    <div class="card mb-4 shadow-sm">
      <h4 class="card-header fw-bold">Charity Details</h4>
      <div class="card-body row">
        <div class="col-md-6 mt-2">
          <p><b>Name:</b> {{ details.donationId?.charityName }}</p>
        </div>
        <div class="col-md-6 mt-2">
          <p><b>Website:</b>
            <a [href]="details.donationId?.websiteLink" target="_blank">
              {{ details.donationId?.websiteLink }}
            </a>
          </p>
        </div>
        <div class="col-md-12 mt-2">
          <p><b>Description:</b></p>
          <p class="text-muted">{{ details.donationId?.charityDescription }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="card mb-4 shadow-sm">
          <h4 class="card-header fw-bold">User Details</h4>
          <div class="card-body">
            <p><b>Name:</b> {{ details.user_id?.name }}</p>
            <p><b>Username:</b> {{ details.user_id?.username }}</p>
            <p><b>Email:</b> {{ details.user_id?.email }}</p>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card mb-4 shadow-sm">
          <h4 class="card-header fw-bold">Store Details</h4>
          <div class="card-body">
            <p><b>Store Name:</b> {{ details.operatorStoreId?.storeName }}</p>
            <p><b>Address:</b> {{ details.operatorStoreId?.storeAddress }}</p>
            <p class="text-muted">{{ details.operatorStoreId?.storeDescription }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-4 shadow-sm">
      <h4 class="card-header fw-bold">Order Details</h4>
      <div class="card-body row">
        <div class="col-md-3"><b>Total (With VAT):</b> {{ details.vendingPurchaseId?.totalAmountWithVat }}</div>
        <div class="col-md-3"><b>VAT Amount:</b> {{ details.vendingPurchaseId?.totalVatAmount }}</div>
        <div class="col-md-3"><b>Delivery Type:</b> {{ details.vendingPurchaseId?.deliveryType }}</div>
        <div class="col-md-3 "><b>Currency:</b> {{ details.vendingPurchaseId?.currency }}</div>

        <div class="col-md-6 mt-2"><b>Delivery Address:</b> {{ details.vendingPurchaseId?.userAddress }}</div>
      </div>
    </div>

    <div class="card shadow-sm">
      <h4 class="card-header fw-bold">Purchased Items</h4>
      <div class="table-responsive">
        <table class="table table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>EAN Number</th>
              <th>Quantity</th>
              <th>Amount (Without VAT)</th>
              <th>VAT</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of details.vendingPurchaseId?.vendingPackagesItems; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.packageId.name }}</td>
              <td>{{ item.packageId.EANNumber }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.totalAmountWithoutVat }}</td>
              <td>{{ item.totalVatAmount }}</td>
              <td>{{ item.chargeableAmount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="loading" class="text-center mt-5">
      <div class="spinner-border text-primary"></div>
    </div>
  </div>